<template>
  <page>
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New Permitted Standard Risk Text
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-flex xs12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.busCls }}</td>
                <td class="text-xs-left">{{ row.item.busClsDesc }}</td>
                <td class="text-xs-left">{{ row.item.stdRiskTxtRef }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    query
                    @query="doQuery(row.item)"
                    review
                    @review="doReview(row.item)"
                    remove
                    @remove="doPromptRemove(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-card>
    <v-dialog v-model="busClsStdRiskTxtReview" width="800px" persistent>
      <v-card>
        <v-toolbar v-if="reviewBusClsStdRiskTxt" dense color="grey lighten-3" flat>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title>Edit Permitted Standard Risk Text </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="newBusClsStdRiskTxt" dense color="grey lighten-3" flat>
          <v-icon>mdi-plus</v-icon>
          <v-toolbar-title>Create Permitted Standard Risk Text</v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="queryBusClsStdRiskTxt" dense color="grey lighten-3" flat>
          <v-toolbar-title>View Permitted Standard Risk Text</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap v-if="newBusClsStdRiskTxt || reviewBusClsStdRiskTxt">
              <v-flex xs6>
                <v-autocomplete
                  :items="buscls"
                  v-model="busClsStdRiskTxtForm.busCls"
                  :label="busClsStdRiskTxtLabel.busCls"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('busClsStdRiskTxtForm.busCls')"
                  data-vv-name="busClsStdRiskTxtForm.busCls"
                  :data-vv-as="busClsStdRiskTxtLabel.busCls"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="queryBusClsStdRiskTxt">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ busClsStdRiskTxtLabel.busCls }}</v-subheader>
                <div class="queryValue" v-for="item in filterBusClsList" :key="item.label">{{ item.label }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="newBusClsStdRiskTxt || reviewBusClsStdRiskTxt">
              <v-flex xs6>
                <v-autocomplete
                  :items="stdrisktxt"
                  v-model="busClsStdRiskTxtForm.stdRiskTxtRef"
                  :label="busClsStdRiskTxtLabel.stdRiskTxtRef"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('busClsStdRiskTxtForm.stdRiskTxtRef')"
                  data-vv-name="busClsStdRiskTxtForm.stdRiskTxtRef"
                  :data-vv-as="busClsStdRiskTxtLabel.stdRiskTxtRef"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="queryBusClsStdRiskTxt">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ busClsStdRiskTxtLabel.stdRiskTxtRef }}</v-subheader>
                <div class="queryValue" v-for="item in filterStdRiskTxtRefList" :key="item.label">{{ item.label }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ busClsStdRiskTxtLabel.createdBy }}</v-subheader>
                <div class="queryValue">{{ busClsStdRiskTxtForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ busClsStdRiskTxtLabel.createdDate }}</v-subheader>
                <div class="queryValue">{{ busClsStdRiskTxtForm.createdDate | formatDate }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newBusClsStdRiskTxt">
                <v-subheader class="queryLabel">{{ busClsStdRiskTxtLabel.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ busClsStdRiskTxtForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newBusClsStdRiskTxt">
                <v-subheader class="queryLabel">{{ busClsStdRiskTxtLabel.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ busClsStdRiskTxtForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="doClose">Cancel</v-btn>
          <v-btn v-if="!queryBusClsStdRiskTxt" color="primary" text @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>Are you sure you want to delete the selected Business Class Standard Risk Text?</p>
      <div class="queryValue">
        {{ selectedBusClsStdRiskTxt.busCls }} - {{ selectedBusClsStdRiskTxt.busClsDesc }}<br />
        {{ selectedBusClsStdRiskTxt.stdRiskTxtRef }}
      </div>
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Business Class', align: 'left', value: 'busCls' },
        { text: 'Description', align: 'left', value: 'busClsDesc' },
        { text: 'Standard Risk Text', align: 'left', value: 'stdRiskTxtRef' },
        TableConst.tableActionHeader
      ],
      busClsStdRiskTxtLabel: {
        busCls: 'Business Class',
        stdRiskTxtRef: 'Standard Risk Text',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      busClsStdRiskTxtForm: {
        busCls: null,
        stdRiskTxtRef: null,
        oldBusCls: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null,
        oldStdRiskTxtRef: null
      },
      menu: {},
      busClsStdRiskTxtReview: false,
      newBusClsStdRiskTxt: false,
      reviewBusClsStdRiskTxt: false,
      queryBusClsStdRiskTxt: false,
      buscls: [],
      stdrisktxt: [],
      selectedBusClsStdRiskTxt: {
        busCls: null,
        busClsDesc: null,
        stdRiskTxtRef: null
      },
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      try {
        await Promise.all([this.$store.dispatch('commonsInit')])
        this.getCommonDataList('buscls')
        this.getCommonDataList('stdrisktxt')
        const apiURI = this.$store.state.busClsParam.menu.getBusClsStdRiskTxtMenu
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.menu = extractMenu(result.data._links)
          }
          this.fetchData(true)
        }
      } catch (err) {
        throw err
      }
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getBusClsStdRiskTxtList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((busClsRiskTxt) => {
                const convertList = {
                  busCls: busClsRiskTxt.busCls,
                  busClsDesc: busClsRiskTxt.busClsDesc,
                  stdRiskTxtRef: busClsRiskTxt.stdRiskTxtRef
                }
                this.items.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.busClsStdRiskTxtForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.busClsStdRiskTxtForm.createdDate = new Date()
      this.busClsStdRiskTxtForm.modifiedBy = null
      this.busClsStdRiskTxtForm.modifiedDate = null
      this.busClsStdRiskTxtReview = true
      this.newBusClsStdRiskTxt = true
      this.reviewBusClsStdRiskTxt = false
      this.queryBusClsStdRiskTxt = false
    },
    doReview(busClsStdRiskTxt) {
      this.resetValidator()
      this.resetMessages()
      if (busClsStdRiskTxt) {
        this.newBusClsStdRiskTxt = false
        this.queryBusClsStdRiskTxt = false
        this.reviewBusClsStdRiskTxt = true
        const apiURI = this.menu.busClsStdRiskTxt
        const expand = {
          busCls: busClsStdRiskTxt.busCls,
          stdRiskTxtRef: busClsStdRiskTxt.stdRiskTxtRef
        }
        if (apiURI) {
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              const { data } = result.data
              if (data) {
                this.busClsStdRiskTxtForm.busCls = data.busClsStdTxt.busCls
                this.busClsStdRiskTxtForm.createdBy = data.createdBy
                this.busClsStdRiskTxtForm.createdDate = data.createdDate
                this.busClsStdRiskTxtForm.modifiedBy = data.modifiedBy
                this.busClsStdRiskTxtForm.modifiedDate = data.modifiedDate
                this.busClsStdRiskTxtForm.oldBusCls = data.busClsStdTxt.busCls
                if (data.busClsStdTxt.stdRiskTxtRef) {
                  this.busClsStdRiskTxtForm.stdRiskTxtRef = data.busClsStdTxt.stdRiskTxtRef
                  this.busClsStdRiskTxtForm.oldStdRiskTxtRef = data.busClsStdTxt.stdRiskTxtRef
                }
                this.busClsStdRiskTxtReview = true
              }
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    },
    async doPromptRemove(busClsStdRiskTxt) {
      this.resetMessages()
      if (busClsStdRiskTxt) {
        try {
          const apiURI = this.menu.checkDeleteBusClsStdRiskTxt
          const expand = {
            busCls: busClsStdRiskTxt.busCls,
            stdRiskTxtRef: busClsStdRiskTxt.stdRiskTxtRef
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selectedBusClsStdRiskTxt.busCls = busClsStdRiskTxt.busCls
          this.selectedBusClsStdRiskTxt.busClsDesc = busClsStdRiskTxt.busClsDesc
          this.selectedBusClsStdRiskTxt.stdRiskTxtRef = busClsStdRiskTxt.stdRiskTxtRef
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.busClsStdRiskTxtForm.busCls = null
      this.busClsStdRiskTxtForm.stdRiskTxtRef = null
      this.busClsStdRiskTxtReview = false
      setTimeout(() => {
        this.newBusClsStdRiskTxt = false
        this.queryBusClsStdRiskTxt = false
        this.reviewBusClsStdRiskTxt = false
      }, 200)
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newBusClsStdRiskTxt) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCreate() {
      const apiURI = this.menu.createBusClsStdRiskTxt
      if (apiURI) {
        this.$http
          .post(apiURI, this.busClsStdRiskTxtForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doInit()
              this.doClose()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doUpdate() {
      const apiURI = this.menu.updateBusClsStdRiskTxt
      if (apiURI) {
        this.$http
          .put(apiURI, this.busClsStdRiskTxtForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doInit()
              this.doClose()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedBusClsStdRiskTxt) {
        const apiURI = this.menu.deleteBusClsStdRiskTxt
        if (apiURI) {
          const expand = {
            busCls: this.selectedBusClsStdRiskTxt.busCls,
            stdRiskTxtRef: this.selectedBusClsStdRiskTxt.stdRiskTxtRef
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doQuery(busClsStdRiskTxt) {
      this.resetValidator()
      this.resetMessages()
      if (busClsStdRiskTxt) {
        this.newBusClsStdRiskTxt = false
        this.queryBusClsStdRiskTxt = true
        this.reviewBusClsStdRiskTxt = false
        const apiURI = this.menu.busClsStdRiskTxt
        const expand = {
          busCls: busClsStdRiskTxt.busCls,
          stdRiskTxtRef: busClsStdRiskTxt.stdRiskTxtRef
        }
        if (apiURI) {
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              const { data } = result.data
              if (data) {
                this.busClsStdRiskTxtForm.busCls = data.busClsStdTxt.busCls
                this.busClsStdRiskTxtForm.createdBy = data.createdBy
                this.busClsStdRiskTxtForm.createdDate = data.createdDate
                this.busClsStdRiskTxtForm.modifiedBy = data.modifiedBy
                this.busClsStdRiskTxtForm.modifiedDate = data.modifiedDate
                this.busClsStdRiskTxtForm.oldBusCls = data.busClsStdTxt.busCls
                if (data.busClsStdTxt.stdRiskTxtRef) {
                  this.busClsStdRiskTxtForm.stdRiskTxtRef = data.busClsStdTxt.stdRiskTxtRef
                }
                this.busClsStdRiskTxtReview = true
              }
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    }
  },
  computed: {
    filterBusClsList() {
      return this.buscls.filter((list) => {
        return list.value === this.busClsStdRiskTxtForm.busCls
      })
    },
    filterStdRiskTxtRefList() {
      return this.stdrisktxt.filter((list) => {
        return list.value === this.busClsStdRiskTxtForm.stdRiskTxtRef
      })
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
<style>
</style>
